<template>
  <div>
    <vs-popup
      :active.sync="infoModal.active"
      title="รายละเอียด"
      class="custom-popup"
    >
      <div class="mb-5">
        <p v-html="infoModal.text"></p>
      </div>
    </vs-popup>

    <vx-card no-shadow title="รายการรายงานทั้งหมด">
      <!-- รายงานทั้งหมด-->
      <vs-list v-if="!isLawyer">
        <vs-list-item title="1. รายงานประจำวัน">
          <vs-button @click="download('reportDaily')" type="line" line-origin="left" color='success'>
            {{ $t("general.download") }}
          </vs-button>
        </vs-list-item>
        <vs-list-item title="2. รายงานผู้ใช้งาน WEL Application">
          <vs-button @click="download('reportWelApplicationUser')" type="line" line-origin="left" color='success'>
            {{ $t("general.download") }}
          </vs-button>
        </vs-list-item>
        <vs-list-item>
          <template #title>
            <span><b>3. รายงานตรวจสอบค่าติดตามทวงถาม (กำหนดเอง)</b></span>&nbsp;
            <a class="cursor-pointer" @click="onPressedActiveInfoModal('reportCheckDebtCollectionFeeCustomForm')">
              <feather-icon icon="InfoIcon" svgClasses="h-4 w-4"/>
            </a>
          </template>
          <div class="flex-container">
            <vs-button @click="download('reportCheckDebtCollectionFeeCustom')" type="line" line-origin="left"
                       color='success'>{{ $t("general.download") }}
            </vs-button>
          </div>
        </vs-list-item>
        <vs-list-item title="4. รายงาแสดงข้อมูลค้ำประกัน">
          <vs-button @click="download('reportContractSureties')" type="line" line-origin="left" color='success'>
            {{ $t("general.download") }}
          </vs-button>
        </vs-list-item>
        <vs-list-item title="5. รายงานสัญญาที่มียอดค้างชำระเพื่อส่ง SMS (สัญญา, ผู้ค้ำประกัน)">
          <vs-button @click="download('reportContractIsAgingSendSms')" type="line" line-origin="left" color='success'>
            {{ $t("general.download") }}
          </vs-button>
        </vs-list-item>
        <vs-list-item title="6. รายงานการดำเนินคดี">
          <vs-button @click="download('reportProsecutions')" type="line" line-origin="left" color='success'>
            {{ $t("general.download") }}
          </vs-button>
        </vs-list-item>
        <vs-list-item title="7. รายงานการชำระเงินลูกค้าหนี้สูญ">
          <vs-button @click="download('reportBadDebtPayments')" type="line" line-origin="left" color='success'>
            {{ $t("general.download") }}
          </vs-button>
        </vs-list-item>
        <vs-list-item title="8. รายงานประวัติสถานะลูกหนี้">
          <vs-button @click="download('reportAgingStageHistory')" type="line" line-origin="left" color='success'>
            {{ $t("general.download") }}
          </vs-button>
        </vs-list-item>
        <vs-list-item title="9. รายงานปรับโครงสร้างหนี้">
          <vs-button @click="download('reportRestructuring')" type="line" line-origin="left" color='success'>
            {{ $t("general.download") }}
          </vs-button>
        </vs-list-item>
      </vs-list>
      <vs-divider position="left" class="text-xl font-bold" v-if="!isLawyer"></vs-divider>
      <!-- รายงานรายปี-->
      <vs-list v-if="!isLawyer">
        <vs-list-item title="1. รายงานประวัติสถานะลูกหนี้ (ใหม่)">
          <div class="flex-container">
            <v-select v-model="reportAgingStageHistoryYearlyForm.year" :clearable="false" :options="yearsOptions"
                      name="year" :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <vs-button @click="download('reportAgingStageHistoryYearly')" type="line" line-origin="left" color='success'>
              {{ $t("general.download") }}
            </vs-button>
          </div>
        </vs-list-item>
        <vs-list-item title="2. รายงานปิดบัญชี">
          <div class="flex-container">
            <v-select v-model="reportClosingAccountYearlyForm.year" :clearable="false" :options="yearsOptions"
                      name="year" :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <vs-button @click="download('reportClosingAccountYearly')" type="line" line-origin="left" color='success'>
              {{ $t("general.download") }}
            </vs-button>
          </div>
        </vs-list-item>
      </vs-list>
      <vs-divider position="left" class="text-xl font-bold" v-if="!isLawyer"></vs-divider>
      <!-- รายงานประจำเดือน-->
      <vs-list v-if="!isLawyer">
        <vs-list-item title="1. รายงานการชำระเงินรายได้อื่นๆ ">
          <div class="flex-container">
            <v-select v-model="reportPaymentExpensesForm.month" :clearable="false" :options="monthsOptions" name="month"
                      :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <v-select v-model="reportPaymentExpensesForm.year" :clearable="false" :options="yearsOptions" name="year"
                      :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <vs-button @click="download('reportPaymentExpenses')" type="line" line-origin="left" color='success'>
              {{ $t("general.download") }}
            </vs-button>
          </div>
        </vs-list-item>
        <vs-list-item title="2. รายงานพนักงานเร่งรัดติดตามหนี้สิน">
          <div class="flex-container">
            <v-select v-model="reportTrackingHistoryForm.month" :clearable="false" :options="monthsOptions" name="month"
                      :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <v-select v-model="reportTrackingHistoryForm.year" :clearable="false" :options="yearsOptions" name="year"
                      :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <vs-button @click="download('reportTrackingHistory')" type="line" line-origin="left" color='success'>
              {{ $t("general.download") }}
            </vs-button>
          </div>
        </vs-list-item>
        <vs-list-item>
          <template #title>
            <span><b>3. รายงานรอบชำระ</b></span>&nbsp;
            <a class="cursor-pointer" @click="onPressedActiveInfoModal('reportPaymentRoundsForm')">
              <feather-icon icon="InfoIcon" svgClasses="h-4 w-4"/>
            </a>
          </template>
          <div class="flex-container">
            <v-select v-model="reportPaymentRoundsForm.month" :clearable="false" :options="monthsOptions" name="month"
                      :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <v-select v-model="reportPaymentRoundsForm.year" :clearable="false" :options="yearsOptions" name="year"
                      :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <vs-button @click="download('reportPaymentRounds')" type="line" line-origin="left" color='success'>
              {{ $t("general.download") }}
            </vs-button>
          </div>
        </vs-list-item>
        <vs-list-item>
          <template #title>
            <span><b>4. รายงานสรุปแผนเงินนำส่ง</b></span>&nbsp;
            <a class="cursor-pointer" @click="onPressedActiveInfoModal('reportLoanDetailPlansForm')">
              <feather-icon icon="InfoIcon" svgClasses="h-4 w-4"/>
            </a>
          </template>
          <div class="flex-container">
            <v-select v-model="reportLoanDetailPlansForm.month" :clearable="false" :options="monthsOptions" name="month"
                      :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <v-select v-model="reportLoanDetailPlansForm.year" :clearable="false" :options="yearsOptions" name="year"
                      :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <vs-button @click="download('reportLoanDetailPlans')" type="line" line-origin="left" color='success'>
              {{ $t("general.download") }}
            </vs-button>
          </div>
        </vs-list-item>
        <vs-list-item>
          <template #title>
            <span><b>5. รายงานตรวจสอบการส่ง Notification</b></span>&nbsp;
            <a class="cursor-pointer" @click="onPressedActiveInfoModal('reportNotificationsForm')">
              <feather-icon icon="InfoIcon" svgClasses="h-4 w-4"/>
            </a>
          </template>
          <div class="flex-container">
            <v-select v-model="reportNotificationsForm.month" :clearable="false" :options="monthsOptions" name="month"
                      :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <v-select v-model="reportNotificationsForm.year" :clearable="false" :options="yearsOptions" name="year"
                      :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <vs-button @click="download('reportNotifications')" type="line" line-origin="left" color='success'>
              {{ $t("general.download") }}
            </vs-button>
          </div>
        </vs-list-item>
        <vs-list-item>
          <template #title>
            <span><b>6. รายงานตรวจสอบสถานะลูกค้าชั้นดี</b></span>&nbsp;
            <a class="cursor-pointer" @click="onPressedActiveInfoModal('reportCustomerSerenadeForm')">
              <feather-icon icon="InfoIcon" svgClasses="h-4 w-4"/>
            </a>
          </template>
          <div class="flex-container">
            <v-select v-model="reportCustomerSerenadeForm.month" :clearable="false" :options="monthsOptions"
                      name="month" :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <v-select v-model="reportCustomerSerenadeForm.year" :clearable="false" :options="yearsOptions" name="year"
                      :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <vs-button @click="download('reportCustomerSerenade')" type="line" line-origin="left" color='success'>
              {{ $t("general.download") }}
            </vs-button>
          </div>
        </vs-list-item>
        <vs-list-item>
          <template #title>
            <span><b>7. รายงานสถานะทางกฎหมาย</b></span>&nbsp;
            <a class="cursor-pointer" @click="onPressedActiveInfoModal('reportProsecutionCaseStatusForm')">
              <feather-icon icon="InfoIcon" svgClasses="h-4 w-4"/>
            </a>
          </template>
          <div class="flex-container">
            <v-select v-model="reportProsecutionCaseStatusForm.month" :clearable="false" :options="monthsOptions"
                      name="month" :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <v-select v-model="reportProsecutionCaseStatusForm.year" :clearable="false" :options="yearsOptions"
                      name="year"
                      :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <vs-button @click="download('reportProsecutionCaseStatus')" type="line" line-origin="left" color='success'>
              {{ $t("general.download") }}
            </vs-button>
          </div>
        </vs-list-item>
      </vs-list>
      <vs-divider position="left" class="text-xl font-bold" v-if="!isLawyer"></vs-divider>
      <!-- รายงานประจำวัน-->
      <vs-list v-if="!isLawyer">
        <vs-list-item>
          <template #title>
            <span><b>1. รายงานประมาณการยอดคงเหลือ</b></span>&nbsp;
            <a class="cursor-pointer" @click="onPressedActiveInfoModal('reportEstimateRemainForm')">
              <feather-icon icon="InfoIcon" svgClasses="h-4 w-4"/>
            </a>
          </template>
          <div class="flex-container">
            <v-select v-model="reportEstimateRemainForm.day" :clearable="false"
                      :options="reportEstimateRemainDaysOptions" name="month" :reduce="res => res.value"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <v-select v-model="reportEstimateRemainForm.month" :clearable="false" :options="monthsOptions" name="month"
                      :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <v-select v-model="reportEstimateRemainForm.year" :clearable="false" :options="yearsOptions" name="year"
                      :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <vs-button @click="download('reportEstimateRemain')" type="line" line-origin="left" color='success'>
              {{ $t("general.download") }}
            </vs-button>
          </div>
        </vs-list-item>
        <vs-list-item>
          <template #title>
            <span><b>2. รายงานการชำระเงิน (รายวัน)</b></span>&nbsp;
            <a class="cursor-pointer" @click="onPressedActiveInfoModal('reportReceiptDailyForm')">
              <feather-icon icon="InfoIcon" svgClasses="h-4 w-4"/>
            </a>
          </template>
          <div class="flex-container">
            <v-select v-model="reportReceiptDailyForm.day" :clearable="false" :options="reportReceiptDailyDaysOptions"
                      name="month" :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <v-select v-model="reportReceiptDailyForm.month" :clearable="false" :options="monthsOptions" name="month"
                      :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <v-select v-model="reportReceiptDailyForm.year" :clearable="false" :options="yearsOptions" name="year"
                      :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <vs-button @click="download('reportReceiptDaily')" type="line" line-origin="left" color='success'>
              {{ $t("general.download") }}
            </vs-button>
          </div>
        </vs-list-item>
        <vs-list-item>
          <template #title>
            <span><b>3. รายงานข้อมูลสำหรับตัดหนี้สูญ (รายวัน)</b></span>&nbsp;
            <a class="cursor-pointer" @click="onPressedActiveInfoModal('reportInformationForCutDebtLostForm')">
              <feather-icon icon="InfoIcon" svgClasses="h-4 w-4"/>
            </a>
          </template>
          <div class="flex-container">
            <v-select v-model="reportInformationForCutDebtLostForm.day" :clearable="false"
                      :options="reportInformationForCutDebtLostFormDaysOptions"
                      name="month" :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <v-select v-model="reportInformationForCutDebtLostForm.month" :clearable="false" :options="monthsOptions"
                      name="month"
                      :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <v-select v-model="reportInformationForCutDebtLostForm.year" :clearable="false" :options="yearsOptions"
                      name="year"
                      :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <vs-button @click="download('reportInformationForCutDebtLost')" type="line" line-origin="left"
                       color='success'>
              {{ $t("general.download") }}
            </vs-button>
          </div>
        </vs-list-item>
        <vs-list-item>
          <template #title>
            <span><b>4. รายงานสรุปยอดแจ้งเตือน (รายวัน)</b></span>&nbsp;
            <a class="cursor-pointer" @click="onPressedActiveInfoModal('reportNotificationCallExListForm')">
              <feather-icon icon="InfoIcon" svgClasses="h-4 w-4"/>
            </a>
          </template>
          <div class="flex-container">
            <v-select v-model="reportNotificationCallExListForm.day" :clearable="false"
                      :options="reportNotificationCallExListFormDaysOptions"
                      name="month" :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <v-select v-model="reportNotificationCallExListForm.month" :clearable="false" :options="monthsOptions"
                      name="month"
                      :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <v-select v-model="reportNotificationCallExListForm.year" :clearable="false" :options="yearsOptions"
                      name="year"
                      :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <vs-button @click="download('reportNotificationCallExList')" type="line" line-origin="left"
                       color='success'>
              {{ $t("general.download") }}
            </vs-button>
          </div>
        </vs-list-item>
      </vs-list>
      <vs-divider position="left" class="text-xl font-bold" v-if="!isLawyer"></vs-divider>
      <!-- รายงานรายสัญญา-->
      <vs-list>
        <vs-list-item>
          <template #title>
            <span><b>1. รายงานตารางคำนวนหนี้</b></span>&nbsp;
            <a class="cursor-pointer" @click="onPressedActiveInfoModal('reportDebtCalculationTableForm')">
              <feather-icon icon="InfoIcon" svgClasses="h-4 w-4"/>
            </a>
          </template>
          <div class="flex-container">
            <v-select
              v-model="reportDebtCalculationTableForm.contractId"
              :clearable="true"
              :options="contractOptions"
              name="contract"
              :reduce="res => res.value"
              class="fixed-width-select"
            />
            <vs-button
              @click="download('reportDebtCalculationTable')"
              type="line"
              line-origin="left"
              color='success'>
              {{ $t("general.download") }}
            </vs-button>
          </div>

        </vs-list-item>
      </vs-list>
    </vx-card>
  </div>
</template>

<script>
import {getReportDate, isLawyer as fncIsLawyer} from "@/utils";
import vSelect from 'vue-select'
import {createNamespacedHelpers, mapGetters} from "vuex";
import {ValidationProvider} from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import Divider from "@/views/components/vuesax/divider/Divider.vue";

const {mapActions: mapAccountingActions} = createNamespacedHelpers('Accounting')

export default {
  components: {
    Divider,
    vSelect,
    ValidationProvider,
    flatPickr
  },
  data() {
    return {
      infoModal: {
        active: false,
        text: ""
      },
      reportServer: process.env.VUE_APP_REPORT_SERVER,
      reportPaymentExpensesForm: {
        year: getReportDate().year,
        month: getReportDate().month,
      },
      reportTrackingHistoryForm: {
        year: getReportDate().year,
        month: getReportDate().month,
      },
      reportPaymentRoundsForm: {
        year: getReportDate().year,
        month: getReportDate().month,
      },
      reportLoanDetailPlansForm: {
        year: getReportDate().year,
        month: getReportDate().month,
      },
      reportNotificationsForm: {
        year: getReportDate().year,
        month: getReportDate().month,
      },
      reportCustomerSerenadeForm: {
        year: getReportDate().year,
        month: getReportDate().month,
      },
      reportProsecutionCaseStatusForm: {
        year: getReportDate().year,
        month: getReportDate().month,
      },
      reportEstimateRemainForm: {
        year: getReportDate().year,
        month: getReportDate().month,
        day: getReportDate().day,
      },
      reportReceiptDailyForm: {
        year: getReportDate().year,
        month: getReportDate().month,
        day: getReportDate().day,
      },
      reportInformationForCutDebtLostForm: {
        year: getReportDate().year,
        month: getReportDate().month,
        day: getReportDate().day,
      },
      reportNotificationCallExListForm: {
        year: getReportDate().year,
        month: getReportDate().month,
        day: getReportDate().day,
      },
      reportAgingStageHistoryYearlyForm: {
        year: getReportDate().year,
      },
      reportClosingAccountYearlyForm: {
        year: getReportDate().year,
      },
      reportDebtCalculationTableForm: {
        contractId: null,
      },
      user: ""
    }
  },
  computed: {
    ...mapGetters({
      yearsOptions: "Master/yearsOptions",
      monthsOptions: "Master/monthsNoNumOptions",
      contractOptions: "Accounting/contractOptions",
    }),
    reportEstimateRemainDaysOptions() {
      const daysInMonth = new Date(this.reportEstimateRemainForm.year, this.reportEstimateRemainForm.month, 0).getDate();
      const days = Array.from({length: daysInMonth}, (v, i) => ({
        value: i + 1,
        label: (i + 1).toString(),
        selected: false
      }));
      return days || [];
    },
    reportReceiptDailyDaysOptions() {
      const daysInMonth = new Date(this.reportReceiptDailyForm.year, this.reportReceiptDailyForm.month, 0).getDate();
      const days = Array.from({length: daysInMonth}, (v, i) => ({
        value: i + 1,
        label: (i + 1).toString(),
        selected: false
      }));
      return days || [];
    },
    reportInformationForCutDebtLostFormDaysOptions() {
      const daysInMonth = new Date(this.reportInformationForCutDebtLostForm.year, this.reportInformationForCutDebtLostForm.month, 0).getDate();
      const days = Array.from({length: daysInMonth}, (v, i) => ({
        value: i + 1,
        label: (i + 1).toString(),
        selected: false
      }));
      return days || [];
    },
    reportNotificationCallExListFormDaysOptions() {
      const daysInMonth = new Date(this.reportNotificationCallExListForm.year, this.reportNotificationCallExListForm.month, 0).getDate();
      const days = Array.from({length: daysInMonth}, (v, i) => ({
        value: i + 1,
        label: (i + 1).toString(),
        selected: false
      }));
      return days || [];
    },
    isLawyer() {
      return fncIsLawyer();
    },
  },
  methods: {
    ...mapAccountingActions(['getContractOptions']),
    async onPressedActiveInfoModal(type) {
      if (type === 'reportEstimateRemainForm') {
        this.infoModal.text = `<b>รายงานประมาณการยอดคงเหลือ</b> สามารถกำหนดวันที่ในอนาคต เพื่อแสดงยอดคงเหลือประมาณการ โดยระบบจะมีการคำนวน<b>"เบี้ยปรับ"</b> และ<b>"ดอกเบี้ย"</b>ถึงวันที่กำหนด <b><u>แต่ไม่สามารถเรียกดูข้อมูลย้อนหลังได้</u></b>`
      } else if (type === 'reportPaymentRoundsForm') {
        this.infoModal.text = `<b>รายงานรอบชำระ</b> ใช้สำหรับตรวจสอบข้อมูลรอบชำระของแต่ละสัญญาในแต่ละเดือนที่กำหนดได้ โดยอีกทั้งยังสามารถ <b>ตรวจสอบยอดกับหน้าแดรชบอร์ด ในส่วนรายการรับชำระ (แท่งสีฟ้า หัวข้อยอดเรียกเก็บ)ได้ </b>`
      } else if (type === 'reportLoanDetailPlansForm') {
        this.infoModal.text = `<b>รายงานสรุปแผนเงินนำส่ง</b> ใช้สำหรับตรวจสอบข้อมูลแผนเงินนำส่งเพื่อประกอบการพิจารณาในการดำเนินการนำส่งเงินค่าเทอม<b>ให้กับทางมหาลัย</b> หรือเงินค่าครองชีพ<b>ให้กับนักศึกษา</b> โดยมีเงือนไขและนโยบายตามที่บริษัทกำหนดไว้`
      } else if (type === 'reportNotificationsForm') {
        this.infoModal.text = `<b>รายงานตรวจสอบการส่ง Notification</b> ใช้สำหรับตรวจสอบการส่ง Notification ให้กับผู้ใช้งาน WEL Application`
      } else if (type === 'reportCheckDebtCollectionFeeCustomForm') {
        this.infoModal.text = `<b>รายงานตรวจสอบค่าติดตามทวงถาม (กำหนดเอง)</b> ระบบจะแสดงรายละเอียดของสัญญา  ,ค่าติดตามทวงถาม (ล่าสุด) ,ค่าติดตามทวงถาม (ล่าสุด ณ เดือนปัจจุบัน)`
      } else if (type === 'reportReceiptDailyForm') {
        this.infoModal.text = `<b>รายงานการชำระเงิน (รายวัน)</b> ระบบจะดึงข้อมูลตาม<b>"รายงานการชำระเงิน"</b> โดยจะเพิ่มข้อมูล 3 column คือ วันที่ค้างชำระ (ก่อนชำระ), จำนวนวันค้างชำระ  (ก่อนชำระ), ลำดับชั้นลูกหนี้  (ก่อนชำระ) โดยข้อมูลดังกล่าวจะใช้ทรัพยากรของระบบสูงในการประมวลผล จึงควร<b><u>"ดึงข้อมูลเป็นรายวันเท่านั้น"</u></b>`
      } else if (type === 'reportCustomerSerenadeForm') {
        this.infoModal.text = `<b>รายงานตรวจสอบสถานะลูกค้าชั้นดี</b> โดยรายงานดังกล่าวจะดึงข้อมูลค้างชำระของลูกค้าย้อนหลัง 12 เดือน <b>"โดยใช้ข้อมูล ณ วันที่ 5 ของทุกเดือน"</b>`
      } else if (type === 'reportProsecutionCaseStatusForm') {
        this.infoModal.text = `<b>รายงานสถานะทางกฎหมาย</b> ใช้สำหรับตรวจสอบสถานะทางกฎหมายของสัญญาในแต่ละเดือนที่กำหนดได้`
      } else if (type === 'reportDebtCalculationTableForm') {
        this.infoModal.text = `<b>รายงานตารางคำนวนหนี้</b> ใช้สำหรับตรวจสอบข้อมูลคำนวนหนี้ของสัญญา โดยสามารถเลือกสัญญาที่ต้องการดูข้อมูลได้`
      } else if (type === 'reportInformationForCutDebtLostForm') {
        this.infoModal.text = `<b>รายงานข้อมูลสำหรับตัดหนี้สูญ (รายวัน)</b>โดยข้อมูลดังกล่าวจะใช้ทรัพยากรของระบบสูงในการประมวลผล จึงควร<b><u>"ดึงข้อมูลเป็นรายวันเท่านั้น"</u></b>`
      } else if (type === 'reportNotificationCallExListForm') {
        this.infoModal.text = `<b>รายงานข้อมูลสำหรับตัดหนี้สูญ (รายวัน)</b>โดยข้อมูลดังกล่าวจะใช้ทรัพยากรของระบบสูงในการประมวลผล จึงควร<b><u>"ดึงข้อมูลเป็นรายวันเท่านั้น"</u></b>`
      }
      this.infoModal.active = true
    },
    async download(report) {
      const vm = this
      let params = {};
      if (report === 'reportPaymentExpenses') {
        params = {
          year: vm.reportPaymentExpensesForm.year,
          month: vm.reportPaymentExpensesForm.month,
        };
      } else if (report === 'reportTrackingHistory') {
        params = {
          year: vm.reportTrackingHistoryForm.year,
          month: vm.reportTrackingHistoryForm.month,
        };
      } else if (report === 'reportPaymentRounds') {
        params = {
          year: vm.reportPaymentRoundsForm.year,
          month: vm.reportPaymentRoundsForm.month,
        };
      } else if (report === 'reportLoanDetailPlans') {
        params = {
          year: vm.reportLoanDetailPlansForm.year,
          month: vm.reportLoanDetailPlansForm.month,
        };
      } else if (report === 'reportNotifications') {
        params = {
          year: vm.reportNotificationsForm.year,
          month: vm.reportNotificationsForm.month,
        };
      } else if (report === 'reportCustomerSerenade') {
        params = {
          year: vm.reportCustomerSerenadeForm.year,
          month: vm.reportCustomerSerenadeForm.month,
        };
      } else if (report === 'reportProsecutionCaseStatus') {
        params = {
          year: vm.reportProsecutionCaseStatusForm.year,
          month: vm.reportProsecutionCaseStatusForm.month,
        };
      } else if (report === 'reportEstimateRemain') {
        params = {
          year: vm.reportEstimateRemainForm.year,
          month: vm.reportEstimateRemainForm.month,
          day: vm.reportEstimateRemainForm.day,
        };
      } else if (report === 'reportReceiptDaily') {
        params = {
          year: vm.reportReceiptDailyForm.year,
          month: vm.reportReceiptDailyForm.month,
          day: vm.reportReceiptDailyForm.day,
        };
      } else if (report === 'reportInformationForCutDebtLost') {
        params = {
          year: vm.reportInformationForCutDebtLostForm.year,
          month: vm.reportInformationForCutDebtLostForm.month,
          day: vm.reportInformationForCutDebtLostForm.day,
        };
      } else if (report === 'reportNotificationCallExList') {
        params = {
          year: vm.reportNotificationCallExListForm.year,
          month: vm.reportNotificationCallExListForm.month,
          day: vm.reportNotificationCallExListForm.day,
        };
      } else if (report === 'reportAgingStageHistoryYearly') {
        params = {
          year: vm.reportAgingStageHistoryYearlyForm.year,
        };
      } else if (report === 'reportClosingAccountYearly') {
        params = {
          year: vm.reportClosingAccountYearlyForm.year,
        };
      } else if (report === 'reportDebtCalculationTable') {
        params = {
          contractId: vm.reportDebtCalculationTableForm.contractId,
        };
      }
      const queryString = new URLSearchParams(params).toString();
      const url = queryString
        ? `${vm.reportServer}/excel/${report}?${queryString}`
        : `${vm.reportServer}/excel/${report}`;
      window.open(url, '_blank');
    },
  },
  async created() {
    const vm = this
    vm.$vs.loading();
    const {getContractOptions} = vm
    if (vm.contractOptions.length === 0) await getContractOptions();
    setTimeout(() => {
      vm.created = true
      vm.$vs.loading.close();
    }, 500);
    // vm.pms ('ProsecutionTransaction', 'create', 'r')
  },
}
</script>

<style>
.flex-container {
  display: flex;
  align-items: center;
  gap: 10px; /* Optional: space between items */
}

.fixed-width-select {
  width: 450px; /* Adjust the width as needed */
}
</style>
